import * as utilities from './utilities';
import * as manageData from './manageData';
import * as manageVideo from './manageVideo';

import * as htmlBuildBracket from './htmlBuildBracket';
import 'leaflet/dist/leaflet';
//import * as firebaseHelpers from './firebase/helpers';
import { times } from 'lodash';
//import { WatchIgnorePlugin } from 'webpack';
import tournysData from './dataTournys';

const leftBar = document.getElementById('LeftBar');
const menu = document.getElementById('LeftBarContainer'); //is this needed (dec 2020)

const LEAGUE_TOURNY_IDS = new Set(['MLS2022', 'EPL2022']);
const TYPE_ORDER = ['MWC', 'MEuro', 'MCopaA', 'WWC', 'WEuro', 'Leagues'];

function getMenuTypeKey(currentTourny) {
	if (LEAGUE_TOURNY_IDS.has(currentTourny.tournyID)) return 'league';
	return currentTourny.typeOfTourny || 'default';
}

function resolveMenuFlags(currentTourny) {
	const flags = { ...settings.menuMatrix.default };
	const typeKey = getMenuTypeKey(currentTourny);
	if (settings.menuMatrix.typeOverrides[typeKey]) {
		Object.assign(flags, settings.menuMatrix.typeOverrides[typeKey]);
	}
	if (settings.menuMatrix.tournyOverrides[currentTourny.tournyID]) {
		Object.assign(flags, settings.menuMatrix.tournyOverrides[currentTourny.tournyID]);
	}
	return flags;
}

function getBracketLayer(currentTourny) {
	if (!currentTourny.bracketVariant || currentTourny.bracketVariant === 'none') return null;
	if (currentTourny.bracketVariant === 'new') return 'newBracketLayerIndex';
	return 'bracketLayerIndex';
}

function sortTournysDescending(list) {
	return list.sort((a, b) => {
		// Sort by startYear, then startMonth, then startDay in reverse chronological order (newest first)
		if (b.startYear !== a.startYear) {
			return b.startYear - a.startYear;
		}
		if (b.startMonth !== a.startMonth) {
			return b.startMonth - a.startMonth;
		}
		if (b.startDay !== a.startDay) {
			return b.startDay - a.startDay;
		}
		return 0;
	});
}

function getAllTournaments() {
	const allTournys = [];

	settings.tournys.forEach((tourny) => {
		// Skip tournaments that are excluded from the menu based on Matrix settings
		const menuFlags = resolveMenuFlags(tourny);
		if (menuFlags.showInMenu === false) return;
		allTournys.push(tourny);
	});

	return sortTournysDescending(allTournys);
}

function buildTournamentSelector() {
	const allTournys = getAllTournaments();
	let text = '';

	text += '<li class="nav-item dropdown">';
	text +=
		'<div id="tournySelector" class="dropdown_main tourny_selectorBase" data-basename="Tournament" data-addname="' +
		settings.globals.currentTourny.menuName +
		'">';
	text += '</div>';
	text += '<div class="dropdown-menu tourny_selectorMenu" data-loading="false" data-index="0">';

	// Build flat menu (non-hierarchical)
	allTournys.forEach((tourny) => {
		text += '<a class="dropdown-item" href="/" data-tournyID="' + tourny.tournyID + '">' + tourny.menuName + '</a>';
	});

	text += '</div>';
	text += '</li>';
	return text;
}

function buildTournamentGroup(type, tournys, displayName) {
	let text = '';
	text += '<div class="dropdown-item dropdown-submenu">';
	text += '<span>' + displayName + ' ▸</span>';
	text += '<div class="dropdown-submenu-content">';
	tournys.forEach((tourny) => {
		text += '<a class="dropdown-item" href="/" data-tournyID="' + tourny.tournyID + '">' + tourny.menuName + '</a>';
	});
	text += '</div>';
	text += '</div>';
	return text;
}

function buildDashboardItems(flags) {
	let text = '';
	if (flags.showAbout) {
		text += '<li class="nav-item"  onclick="switchModes(settings.layerIndices.aboutLayerIndex)">About</li>';
	}
	if (settings.globals.currentTourny.useLeagueDashboard) {
		if (!settings.globals.currentTourny.playerListReady)
			text +=
				'<li class="nav-item" data-start_layer onclick="switchModes(settings.layerIndices.wideLeagueDashboardLayerIndex)">Dashboard</li>';
		else
			text +=
				'<li class="nav-item"  onclick="switchModes(settings.layerIndices.leagueDashboardLayerIndex)">Dashboard</li>';
	} else {
		if (!settings.globals.currentTourny.playerListReady)
			text +=
				'<li class="nav-item"  data-start_layer onclick="switchModes(settings.layerIndices.wideDashboardLayerIndex)">Dashboard</li>';
		else
			text +=
				'<li class="nav-item" data-start_layer onclick="switchModes(settings.layerIndices.dashQualLayerIndex)">Dashboard</li>';
	}
	return text;
}

function buildScheduleMenu(flags) {
	if (!flags.showSchedule) {
		return '';
	}
	if (settings.globals.currentTourny.useLeagueDashboard) {
		return '<li class="nav-item" onclick="switchModes(settings.layerIndices.leagueScheduleLayerIndex)">Schedule</li>';
	} else {
		return '<li class="nav-item" onclick="switchModes(settings.layerIndices.scheduleLayerIndex)">Schedule</li>';
	}
}

function buildResultsMenu(flags) {
	const currentTourny = settings.globals.currentTourny;
	const scheduleFormat = currentTourny.scheduleFormat;
	const hasRound32 = scheduleFormat === 'threeRoundsToThirtyTwoKnockOut';
	const hasRound16 = hasRound32 || scheduleFormat === 'threeRoundsToSixteenKnockOut';

	let text = '';
	text += '<li class="nav-item dropdown">';
	text += '<div class="dropdown_main" data-basename="Results" data-addname=""></div>';
	text += '<div class="dropdown-menu">';

	if (flags.showLeagueResults) {
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.leagueResultsLayerIndex)">All</a>';
	}

	if (flags.showKnockoutResults) {
		if (flags.showKnockoutResultsRound2) {
			text +=
				'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.r2LayerIndex)">Final</a>';
		}
		if (flags.showKnockoutResultsRound4) {
			text +=
				'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.r4LayerIndex)">Semi-Finals</a>';
		}
		if (flags.showKnockoutResultsRound8) {
			text +=
				'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.r8LayerIndex)">Qtr-Finals</a>';
		}
		if (flags.showKnockoutResultsRound16 && (hasRound32 || hasRound16)) {
			text +=
				'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.r16LayerIndex)">Round Of Sixteen</a>';
		}
		if (flags.showKnockoutResultsRound32 && hasRound32) {
			text +=
				'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.r32KnockOutLayerIndex)">Round Of Thirty-Two</a>';
		}
		// Handle group stage breakdown: false/0 = no group stage, 3 = three rounds, 5 = five rounds
	}
	if (flags.showGroupResultsBreakdown === 5) {
		// Five rounds: show Overall, Round 5, Round 4, Round 3, Round 2, Round 1
		if (flags.showStageResultsOverall) {
			text +=
				'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupStageOverallLayerIndex)">Group Stage, Overall</a>';
		}
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupStageRoundFiveLayerIndex)">Group Stage, Round 5</a>';
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupStageRoundFourLayerIndex)">Group Stage, Round 4</a>';
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupStageRoundThreeLayerIndex)">Group Stage, Round 3</a>';
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupStageRoundTwoLayerIndex)">Group Stage, Round 2</a>';
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupStageRoundOneLayerIndex)">Group Stage, Round 1</a>';
	} else if (flags.showGroupResultsBreakdown === 3) {
		// Three rounds: show Overall, Round 3, Round 2, Round 1
		if (flags.showStageResultsOverall) {
			text +=
				'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupStageOverallLayerIndex)">Group Stage, Overall</a>';
		}
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupStageRoundThreeLayerIndex)">Group Stage, Round 3</a>';
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupStageRoundTwoLayerIndex)">Group Stage, Round 2</a>';
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupStageRoundOneLayerIndex)">Group Stage, Round 1</a>';
	}
	// If showGroupResultsBreakdown is false/0, no group stage menus are shown

	const bracketLayer = getBracketLayer(settings.globals.currentTourny);
	if (bracketLayer) {
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.' +
			bracketLayer +
			')">Bracket</a>';
	}

	text += '</div>';
	text += '</li>';
	return text;
}

function buildGroupsMenu(flags) {
	let text = '';
	text += '<li class="nav-item dropdown">';
	text += '<div class="dropdown_main" data-basename="Groups" data-addname=""></div>';
	text += '<div class="dropdown-menu">';
	if (flags.showLeaders) {
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupLeadersLayerIndex)">Group Leaders</a>';
	}
	if (flags.showLeadersAndSecondPlace) {
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupTopTwoLayerIndex)">Leaders and Second Place</a>';
	}
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.groupsLayerIndex)">All Teams</a>';
	text += '</div>';
	text += '</li>';
	return text;
}

function buildTalentFlowMenu(flags) {
	const confedFrom = flags.showTalentFlowConfedFrom;
	const confedTo = flags.showTalentFlowConfedTo;
	let text = '';
	text += '<li class="nav-item dropdown">';
	text += '<div class="dropdown_main" data-basename="Talent Flow" data-addname=""></div>';
	text += '<div class="dropdown-menu">';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.talentFlowFromCountryLayerIndex)">From Country</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.talentFlowToCountryLayerIndex)">To Country</a>';
	if (confedFrom)
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.talentFlowFromConfederationLayerIndex)">From Confederation</a>';
	if (confedTo)
		text +=
			'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.talentFlowToConfederationLayerIndex)">To Confederation</a>';
	text += '</div>';
	text += '</li>';
	return text;
}

function buildQualifyingMenu() {
	return '<li class="nav-item" onclick="switchModes(settings.layerIndices.qualifyingLayerIndex)">Qualifying</li>';
}

function buildVideosMenu() {
	let text = '';
	text += '<li class="nav-item dropdown">';
	text += '<div class="dropdown_main" data-basename="Videos" data-addname=""></div>';
	text += '<div class="dropdown-menu dropdown-menu-right">';
	text +=
		'<a class="dropdown-item" data-start_layer_alt href="/" onclick="switchModes(settings.layerIndices.helpLayerIndex)">Getting Started</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.MWCVideosLayerIndex)">World Cup, 1930 - 2022</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.WWCVideosLayerIndex)">Womens WC, 1990 - 2023</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.MEuroVideosLayerIndex)">Euro, 1960 - 2024</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.greatMPlayerVideosLayerIndex)">Great Players, Men</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.greatWPlayerVideosLayerIndex)">Great Players, Women</a>';
	text += '</div>';
	text += '</li>';
	return text;
}

function buildInsightsMenu() {
	let text = '';
	text += '<li class="nav-item dropdown">';
	text += '<div class="dropdown_main" data-basename="Insights" data-addname=""></div>';
	text += '<div class="dropdown-menu dropdown-menu-right">';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.MRankingsLayerIndex)">Rankings</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.MWCHistoryLayerIndex)">World Cup History</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.MWCFinalistsLayerIndex)">World Cup Champions</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.MEuroHistoryLayerIndex)">Euro History</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.MEuroFinalistsLayerIndex)">Euro Champions</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.CopaAmericaHistoryLayerIndex)">Copa America History</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.CopaAmericaFinalistsLayerIndex)">Copa America Champions</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.WWCHistoryLayerIndex)">Womens WC History</a>';
	text +=
		'<a class="dropdown-item" href="/" onclick="switchModes(settings.layerIndices.WWCFinalistsLayerIndex)">Womens WC Champions</a>';
	text += '</div>';
	text += '</li>';
	return text;
}

function buildMoreMenu() {
	let text = '';
	text += '<li class="nav-item dropdown">';
	text += '<div class="dropdown_main" data-basename="More" data-addname=""></div>';
	text += '<div class="dropdown-menu dropdown-menu-right">';
	text +=
		'<a class="dropdown-item" data-coffee_layer href="/" onclick="switchModes(settings.layerIndices.buyMeCoffeeLayerIndex)">Buy Us A Coffee</a>';
	text +=
		'<a class="dropdown-item" data-sendEmail_layer href="/" onclick="switchModes(settings.layerIndices.contactLayerIndex)">Contact Us</a>';
	text +=
		'<a class="dropdown-item" data-terms_layer href="/" onclick="switchModes(settings.layerIndices.termsLayerIndex)">Terms Of Use</a>';
	text +=
		'<a class="dropdown-item" data-privacy_layer href="/" onclick="switchModes(settings.layerIndices.privacyLayerIndex)">Privacy Policy</a>';
	text += '</div>';
	text += '</li>';
	return text;
}

function buildMenuSections() {
	const flags = resolveMenuFlags(settings.globals.currentTourny);
	let text = '';
	text += buildTournamentSelector();
	text += buildDashboardItems(flags);
	text += buildScheduleMenu(flags);
	if (flags.showGroups) text += buildGroupsMenu(flags);
	if (flags.showResults) text += buildResultsMenu(flags);
	if (flags.showTalentFlow) text += buildTalentFlowMenu(flags);
	if (flags.showQualifying) text += buildQualifyingMenu();
	if (flags.showVideos) text += buildVideosMenu();
	if (flags.showInsights) text += buildInsightsMenu();
	if (flags.showMore) text += buildMoreMenu();
	return text;
}

function initializeMenuAndSideBar() {
	const header = document.getElementById('Header');
	if (header) {
		header.innerHTML = buildHeader();
	}
}

function buildManageAccount() {
	let returnText =
		'<div class="generalTextDisplay">' +
		'<div id="mySpinner">' +
		'</div>' +
		'You are being redirected to your account portal.<br>' +
		'</div>';
	leftBar.innerHTML = returnText;
}

function buildNewsLetter() {
	let returnText =
		'<div class="generalTextDisplay leftDisplay">' +
		'Along with futbol fans from around the world, you will receive our newsletter with news about our site and about futbol.' +
		'<br><br>' +
		'You will be able to unsubscribe at any time.' +
		'<br><br>' +
		'<a class="textLinks" target=”_blank” href="' +
		settings.misc.newsLetterLink +
		'">Join</a>' +
		'</div>';
	leftBar.innerHTML = returnText;
}
// all of this is necessary to make sure that the bracket is built with the correct team on top and
// the correct team on the bottom (by paying attention to who won in the previous round)

function buildAbout() {
	let returnText =
		'<div class="generalTextDisplay leftDisplay" style="line-height: 1.6 !important; color: #000000 !important; padding: 20px !important; border-radius: 8px !important;">' +
		'<h2 style="color: #aa1110 !important; font-weight: 800 !important;">OneWorld-Futbol</h2>' +
		'<h3 style="font-weight: 700 !important; color: #000000 !important;">The Visual Pulse of the 2026 World Cup</h3>' +
		'<span style="color: #000000 !important;">In the broadcast studio, every second counts. You don\'t have time to dig through spreadsheets; you need to see the state of the tournament at a glance. OneWorld-Futbol is the definitive visual command center for the 2026 FIFA World Cup, designed specifically for announcers and journalists to track the tournament\'s macro-story as it unfolds across North America.</span>' +
		'<br><br>' +
		'<h3 style="font-weight: 700 !important; color: #000000 !important;">The "Election Night" Experience for the 2026 World Cup</h3>' +
		'<span style="color: #000000 !important;">The centerpiece of our platform is a highly intuitive interactive map. Much like a high-stakes election night broadcast, our map allows you to visualize the entire tournament landscape. With a single click, you can toggle between group standings and watch the bracket evolve in real-time. We\'ve turned data into a living, breathing geography of football.</span>' +
		'<br><br>' +
		'<h3 style="font-weight: 700 !important; color: #000000 !important;">Our Mission</h3>' +
		'<span style="color: #000000 !important;">' +
		'Our mission is to bridge the gap between complex match results and compelling sports storytelling. We provide the visual clarity that allows broadcasters to explain the "tournament landscape" for the 48 competing nations, ensuring that every result and scenario is delivered with precision to a global audience.' +
		'</span>' +
		'<br><br>' +
		'<h3 style="font-weight: 700 !important; color: #000000 !important;">What We Provide</h3>' +
		'<span style="color: #000000 !important;">' +
		'OneWorld-Futbol is the essential companion for the modern broadcaster:' +
		'</span>' +
		'<br><br>' +
		'<div style="margin-left: 1.5em;">' +
		'<strong style="font-weight: 700 !important; color: #000000 !important;">Interactive Map Interface:</strong> <span style="color: #000000 !important;">A bird\'s-eye view of the tournament. Instantly see which nations are dominating the map and how the continental balance of power is shifting across the three host nations.</span>' +
		'<br><br>' +
		'<strong style="font-weight: 700 !important; color: #000000 !important;">Dynamic Group & Schedule Tracking:</strong> <span style="color: #000000 !important;">See the "path to the trophy" through a clean visual UI. No more scrolling through endless lists—just instant, color-coded updates on who has advanced, who is on the bubble, and what is at stake in upcoming matches.</span>' +
		'<br><br>' +
		'<strong style="font-weight: 700 !important; color: #000000 !important;">Real-Time Progress Data:</strong> <span style="color: #000000 !important;">As the 104 matches progress, our interface updates to show the immediate impact on the standings, making it easy to explain complex advancement math to your viewers.</span>' +
		'</div>' +
		'<br>' +
		'<h3 style="font-weight: 700 !important; color: #000000 !important;">Why "One World"?</h3>' +
		'<span style="color: #000000 !important;">' +
		'The 2026 World Cup is more than a tournament; it is a historic collaboration of three nations and a celebration of a global community. Our name reflects the sport\'s unique power to erase borders. Whether your broadcast is based in Mexico City, Toronto, or New York, OneWorld-Futbol ensures your analysis is unified, visually grounded, and truly world-class.' +
		'</span>' +
		'<br><br>' +
		'<h3 style="font-weight: 700 !important; color: #000000 !important;">More Info</h3>' +
		'<a href="mailto:info@OneWorld-Futbol.com" style="color: #aa1110 !important; font-weight: bold !important;">info@OneWorld-Futbol.com</a>' +
		'</div>';
	leftBar.innerHTML = returnText;
}

/**
 * Help layer videos. Vimeo embeds (player.vimeo.com/video/{vimeoId}).
 * vimeoId = numeric ID from the video URL (e.g. vimeo.com/123456789 → 123456789).
 */
const HELP_VIDEO_ENTRIES = [
	{ vimeoId: '1167235659', title: 'Introduction' },
	{ vimeoId: '1167236916', title: 'Dashboard' },
	{ vimeoId: '1167235685', title: 'Schedule' },
	{ vimeoId: '1167235719', title: 'Groups' },
	{ vimeoId: '1167235758', title: 'Results' },
	{ vimeoId: '1167902297', title: 'Talent Flow' },
	{ vimeoId: '1167235565', title: 'Videos' },
	{ vimeoId: '1167235615', title: 'Insights' },
];

const VIMEO_EMBED_BASE = 'https://player.vimeo.com/video/';
const VIMEO_EMBED_PARAMS = 'title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479&controls=1&buttons_position=bottom&quality=1080p';

function hasVimeoId(entry) {
	const id = entry.vimeoId != null ? String(entry.vimeoId).trim() : '';
	return id.length > 0 && /^\d+$/.test(id);
}

function getHelpVideoEmbedSrc(video, autoplay) {
	if (!hasVimeoId(video)) return '';
	const base = VIMEO_EMBED_BASE + encodeURIComponent(String(video.vimeoId).trim()) + '?' + VIMEO_EMBED_PARAMS;
	return autoplay ? base + '&autoplay=1' : base;
}

const VIMEO_OEMBED_URL = 'https://vimeo.com/api/oembed.json?url=';

/**
 * Fetch Vimeo oEmbed for a video ID; returns a Promise that resolves to thumbnail_url or null.
 */
function fetchVimeoThumbnailUrl(vimeoId) {
	const url = VIMEO_OEMBED_URL + encodeURIComponent('https://vimeo.com/' + String(vimeoId).trim());
	return fetch(url)
		.then((res) => (res.ok ? res.json() : null))
		.then((data) => (data && data.thumbnail_url ? data.thumbnail_url : null))
		.catch(() => null);
}

/**
 * Load thumbnails for all sidebar items that have data-vimeo-id. Run after buildHelp() has set leftBar.innerHTML.
 */
function loadHelpThumbnails() {
	const container = document.getElementById('LeftBar');
	if (!container) return;
	container.querySelectorAll('.helpSidebarThumbImg').forEach((img) => {
		const vimeoId = img.getAttribute('data-vimeo-id');
		if (!vimeoId) return;
		fetchVimeoThumbnailUrl(vimeoId).then((thumbnailUrl) => {
			if (thumbnailUrl) {
				img.onerror = function () {
					this.style.display = 'none';
				};
				img.src = thumbnailUrl;
			}
		});
	});
}

/**
 * Switch the main Getting Started video to the given index. Exposed globally for onclick.
 * @param {number|string} index - Video index in HELP_VIDEO_ENTRIES
 * @param {boolean} [autoplay=false] - If true, the loaded video starts playing (use for sidebar clicks; not on initial load)
 */
function selectHelpVideo(index, autoplay) {
	const mainIframe = document.getElementById('helpMainIframe');
	const mainTitle = document.getElementById('helpMainTitle');
	const sidebarItems = document.querySelectorAll('.helpSidebarItem');
	if (!mainIframe || !mainTitle || !sidebarItems.length) return;
	const i = Math.max(0, Math.min(parseInt(index, 10), HELP_VIDEO_ENTRIES.length - 1));
	const video = HELP_VIDEO_ENTRIES[i];
	const src = getHelpVideoEmbedSrc(video, !!autoplay);
	mainIframe.src = src;
	mainTitle.textContent = video.title;
	sidebarItems.forEach((el, j) => {
		el.classList.toggle('helpSidebarItem--active', j === i);
	});
}

/**
 * Build the Help / Getting Started layer: left 5/6 = selected video (default Introduction),
 * right 1/6 = single column of all 8 videos with titles. All videos 16:9. Click sidebar to select.
 */
function buildHelp() {
	const bufferPx = 12;

	function esc(s) {
		return String(s)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	const defaultIndex = 0;
	const defaultVideo = HELP_VIDEO_ENTRIES[defaultIndex];
	const defaultSrc = getHelpVideoEmbedSrc(defaultVideo);
	const defaultTitle = esc(defaultVideo.title);

	// Main area: video wrap contains title (just above) + 16:9 video so gap is maintained on resize
	const mainHtml =
		'<div class="helpMain">' +
		'<div class="helpMainVideoWrap">' +
		'<div id="helpMainTitle" class="helpMainTitle">' + defaultTitle + '</div>' +
		'<div class="helpVideoAspectBox helpMainAspectBox">' +
		'<div class="helpAspectInner">' +
		'<iframe id="helpMainIframe" src="' + esc(defaultSrc) + '" frameborder="0" allow="fullscreen; picture-in-picture" title="' + defaultTitle + '" allowfullscreen></iframe>' +
		'</div></div></div></div>';

	// Sidebar: 8 items, each with title and 16:9 box (clickable). No iframe on right—click plays on left only (YouTube-style).
	let sidebarHtml = '<div class="helpSidebar">';
	for (let i = 0; i < HELP_VIDEO_ENTRIES.length; i++) {
		const v = HELP_VIDEO_ENTRIES[i];
		const safeTitle = esc(v.title);
		const hasVideo = hasVimeoId(v);
		const activeClass = i === defaultIndex ? ' helpSidebarItem--active' : '';
		sidebarHtml +=
			'<button type="button" class="helpSidebarItem' + activeClass + '" data-video-index="' + i + '" title="' + safeTitle + '">' +
			'<span class="helpSidebarItemTitle">' + safeTitle + '</span>' +
			'<div class="helpSidebarThumbWrap helpVideoAspectBox">';
		if (hasVideo) {
			sidebarHtml +=
				'<div class="helpAspectInner">' +
				'<img class="helpSidebarThumbImg" data-vimeo-id="' +
				esc(String(v.vimeoId)) +
				'" alt="" />' +
				'<div class="helpSidebarThumbPlaceholder helpSidebarThumbPlay" aria-hidden="true"></div>' +
				'</div>';
		} else {
			sidebarHtml += '<div class="helpAspectInner helpSidebarThumbPlaceholder">No video</div>';
		}
		sidebarHtml += '</div></button>';
	}
	sidebarHtml += '</div>';

	const html =
		'<div class="helpLayout helpLayout--mainSidebar">' +
		'<div class="helpLayoutHeader">Getting Started</div>' +
		'<div class="helpLayoutBody">' +
		mainHtml +
		sidebarHtml +
		'</div></div>';
	leftBar.innerHTML = html;

	// Click handlers for sidebar items: switch main video and autoplay when loaded
	leftBar.querySelectorAll('.helpSidebarItem').forEach((btn) => {
		btn.addEventListener('click', function () {
			const idx = this.getAttribute('data-video-index');
			if (idx !== null) selectHelpVideo(idx, true);
		});
	});

	// Expose for any legacy onclick use
	window.selectHelpVideo = selectHelpVideo;

	loadHelpThumbnails();

	const vimeoScript = document.createElement('script');
	vimeoScript.src = 'https://player.vimeo.com/api/player.js';
	vimeoScript.async = true;
	leftBar.appendChild(vimeoScript);
}

function buildComingSoon() {
	let returnText = '<div class="generalTextDisplay">';
	returnText += 'The players for World Cup 2022 have not yet';
	returnText += '< br > ' + 'been announced by their countries.';
	returnText += '<br><br>';
	returnText += 'To see how this feature works, switch to the 2018 World Cup.';
	returnText += '</div>';
	leftBar.innerHTML = returnText;
}

function buildEmailThankYou() {
	let returnText = '<div class="generalTextDisplay">';
	returnText += 'Thank You.' + '</br>We are looking forward to reading your message.';
	returnText += '</div>';
	leftBar.innerHTML = returnText;
}

function buildLogIn() {
	let returnText = '<div class="generalTextDisplay">';
	returnText += 'Thank You.' + '</br>You are signed in<br>with a subscription.';
	returnText += '</div>';
	leftBar.innerHTML = returnText;
}

function buildLogOut() {
	let returnText = '<div class="generalTextDisplay">';
	returnText += 'Thank You.' + '</br>You are signed out.';
	returnText += '</div>';
	leftBar.innerHTML = returnText;
}

/**
 * Wraps a string in a span with a class that highlight the element
 * @param theTextToWrap
 * @returns {string}
 */
function wrapInHighlight(theTextToWrap) {
	return '<span class="highlight">' + theTextToWrap + '</span>';
}

/**
 * @param theText
 * @returns {string}
 */
function myBold(theText) {
	return '<strong>' + theText + '</strong>';
}

function buildDidNotQualifyPopUp(entityID) {
	let returnText = '';
	if (entityID) returnText = buildFlag(entityID);
	return returnText + 'Did not qualify.';
}

function buildDidQualifyPopUp(theTeamName) {
	return myBold(theTeamName) + ' Qualified!';
}

function buildQualifyingPopUp(entityName, theConfedText, message, entityID = null) {
	let returnText = '';
	if (entityID) returnText = buildFlag(entityID);
	return returnText + myBold(theConfedText) + '<br>' + message;
}

/**
 * Builds HTML for a country flag image
 * @param {string} countryID - The country ID (returns empty string if 'TBD' or falsy)
 * @param {string} className - Optional CSS class name for the flag div (defaults to 'flag')
 * @param {boolean} useContainer - Whether to wrap in flag-container (defaults to true, but no background bar)
 * @returns {string} HTML string for the flag div with img tag
 */
function buildFlag(countryID, className = 'flag', useContainer = true, customLabel = null, customSublabel = null) {
	if (countryID === 'TBD' || !countryID) {
		return '';
	}
	if (useContainer) {
		const countryName = customLabel !== null ? customLabel : manageData.getProperEntityName(countryID);
		const sublabelHtml = customSublabel
			? '<br><span class="flag-sublabel">' + customSublabel + '</span>'
			: '';
		const hasSublabelClass = customSublabel ? ' has-sublabel' : '';
		return '<div class="flag-container' + hasSublabelClass + '"><div class="' + className + '"><img src=' + htmlBuildBracket.getIconSource(countryID) + '></div><div class="flag-country-name">' + myBold(countryName) + sublabelHtml + '</div></div>';
	} else {
		return '<div class="' + className + '"><img src=' + htmlBuildBracket.getIconSource(countryID) + '></div>';
	}
}

function buildUpcomingGamePopUp(
	theYear,
	theMonth,
	theDay,
	theTime,
	theRound,
	firstTeamName,
	secondTeamName,
	showTimeZone = true
) {
	return (
		myBold(buildDateForMatch(null, theMonth, theDay, theTime, false, showTimeZone)) + // don't include year
		' ' + theRound +
		'<br>' +
		firstTeamName +
		' vs ' +
		secondTeamName
	);
}

function buildDidAdvancePopUp(theEntityName, entityID = null) {
	let returnText = '';
	if (entityID) returnText = buildFlag(entityID);
	return returnText + 'Advanced to knockout stage.<br>';
}

function buildDidNotAdvancePopUp(theEntityName, entityID = null) {
	let returnText = '';
	if (entityID) returnText = buildFlag(entityID);
	return returnText + 'Did not advance to knockout stage.<br>';
}

function buildSingleMatchPopUp(
	theYear,
	theMonth,
	theDay,
	theTime,
	theRoundText,
	firstTeamName,
	firstTeamScore,
	opponentName,
	opponentScore,
	pkShootOut,
	matchIDForVideo,
	showTimeZone = true
) {
	let videoButtonCodeOpen = null;
	let videoButtonCodeClose = null;
	let returnText = '';
	returnText +=
		myBold(buildDateForMatch(null, theMonth, theDay, null, false, showTimeZone)) + theRoundText; // don't include year or time

	if (matchIDForVideo) {
		videoButtonCodeOpen =
			'<div class="universalCameraContainer">' + '<a href="#" class="universalCamera" onclick="handleVideo(';
		videoButtonCodeClose = ')"></a>' + '</div>';
		returnText += videoButtonCodeOpen + matchIDForVideo + videoButtonCodeClose;
	}

	returnText +=
		'<br>' + firstTeamName + '&nbsp' + firstTeamScore + '&nbsp-&nbsp' + opponentName + '&nbsp' + opponentScore;
	if (pkShootOut) returnText += '<br>*penalty kicks';
	return returnText;
}

function buildNextLine(resultsSoFar) {
	return '<br>' + resultsSoFar + '<br>';
}

function buildFullResultsPopUp(teamName, theResults) {
	return 'Schedule: ' + theResults;
}

function buildLostInPreviousPopUp(theEntityName, theMessage, opponentName, type, entityID = null) {
	let returnText = '';
	if (entityID) returnText = buildFlag(entityID);
	if (type === 1)
		return returnText + theMessage + '.<br>';
	else
		return returnText + 'Lost in: ' + '<br>' + theMessage + ' to ' + opponentName + '.<br>';
}

function buildTalentFlowToCountryPopUp(nounPart, teamName, messageA, playersInEntity, messageB) {
	return (
		'<div class="super_title">' +
		nounPart +
		myBold(teamName) +
		messageA +
		'<br>' +
		myBold(playersInEntity) +
		messageB +
		'<div>'
	);
}

function buildTalentFlowFromConfederationPopUp(confederationName, playersLeaving) {
	if (playersLeaving === 0) {
		return (
			'There are no ' +
			settings.globals.currentTourny.shortName +
			' players from ' +
			myBold(confederationName) +
			'<br> leaving the confederation.'
		);
	} else
		return (
			'To play on their club team, ' +
			myBold(playersLeaving) +
			'&nbsp' +
			settings.globals.currentTourny.shortName +
			'<br>players leave the ' +
			myBold(confederationName) +
			' confederaration.'
		);
}

function buildTalentFlowToConfederationPopUp(confederationName, playersEntering) {
	if (playersEntering === 0) {
		return (
			'There are no ' +
			settings.globals.currentTourny.shortName +
			' players entering the<br>' +
			myBold(confederationName) +
			' confederation to play on a club team.'
		);
	} else
		return (
			'To play on their club team, ' +
			myBold(playersEntering) +
			'&nbsp' +
			settings.globals.currentTourny.shortName +
			'<br>players enter the ' +
			myBold(confederationName) +
			' confederaration.'
		);
}

function buildRankingsPopUp(teamName, ranking, points, entityID = null) {
	let returnText = '';
	if (entityID) returnText = buildFlag(entityID);
	return (
		returnText +
		'At the beginning of the tourny, ' +
		myBold(teamName) +
		' was ranked number ' +
		myBold(ranking) +
		' in the world with ' +
		points +
		' points. '
	);
}

/**
 * @param theClub
 * @returns {string|*}
 */
function buildTalentFlowFromCountryPopUp(numOfPlayers, adjective, messageA, location) {
	return '<div class="super_title">' + numOfPlayers + '&nbsp' + myBold(adjective) + messageA + location + '.<div>';
}

function buildIndividualPlayerPopUp(
	clubLocation,
	clubName,
	playerName,
	age,
	position,
	jerseyNumber,
	caps,
	goals,
	height,
	weight,
	nationality
) {
	let returnText = myBold(playerName) + '<br>';
	if (age) {
		returnText += 'Age: ' + age + '<br>';
	}
	if (position) {
		returnText += 'Position: ' + position + '<br>';
	}
	if (jerseyNumber) {
		returnText += 'Jersey: ' + jerseyNumber + '<br>';
	}
	if (caps) {
		returnText += 'Caps: ' + caps + '<br>';
	}
	if (goals) {
		returnText += 'Goals: ' + goals + '<br>';
	}
	if (height) {
		returnText += 'Height: ' + height + '<br>';
	}
	if (weight) {
		returnText += 'Weight: ' + weight + '<br>';
	}
	if (nationality) {
		returnText += 'Nationality: ' + nationality + '<br>';
	}
	if (clubName) {
		returnText += 'Club in ' + myBold(clubLocation) + ': ' + clubName;
	}
	return returnText;
}

/**
 * @param theMatch
 * @param whichTeam
 * @returns {string|*}
 */
function showBlankOrScore(theMatch, whichTeam) {
	let returnText = '';
	if (theMatch.matchCompleted) {
		if (whichTeam === 1) returnText = theMatch.teamOneScore;
		else if (whichTeam === 2) returnText = theMatch.teamTwoScore;
		if (theMatch.penaltyKickShootout) returnText += '*';
	}
	return returnText;
}

/**
 * @returns {string}
 */
function buildSideBarText() {
	let sideText = '';
	let openOfMatch = '';
	let closeOfMatch = '';
	let openOfButton = '';
	let closeOfButton = '';
	let dateTimeCode = '';
	let scoreCode = '';
	let allTogetherCode = '';
	let videoButtonCodeOpen = '<div class="actions">' + '<a href="#" class="camera" onclick="handleVideo(';
	let videoButtonCodeClose = ')"></a>' + '</div>';

	let theDateOfGame = '';
	let gamesPerRound = settings.globals.currentTourny.gamesPerRound;
	settings.globals.currentMatches = utilities.sortMatchesChrono(settings.globals.currentMatches, false); //true means reverse

	//need to calculate where the anchor to scroll to should go.
	let theK = 0;
	let stillSearching = true;
	let firstDayWithoutCompletedMatch = 0;
	let firstMonthWithoutCompletedMatch = 0;
	let firstYearWithoutCompletedMatch = 0;
	//go through looking for first match that hasn't ended

	for (let k = 0; k < settings.globals.currentMatches.length && stillSearching; k++) {
		if (stillSearching) {
			if (!settings.globals.currentMatches[k].matchCompleted) {
				// found an incompleted match
				stillSearching = false;

				firstDayWithoutCompletedMatch = settings.globals.currentMatches[k].day;
				firstMonthWithoutCompletedMatch = settings.globals.currentMatches[k].month;
				firstYearWithoutCompletedMatch = settings.globals.currentMatches[k].year;
			}
		}
	}

	//now go through the same list and find the  k of the first match (could be a completed match) that has
	stillSearching = true;
	for (let k = 0; k < settings.globals.currentMatches.length && stillSearching; k++) {
		if (
			settings.globals.currentMatches[k].day === firstDayWithoutCompletedMatch &&
			settings.globals.currentMatches[k].month === firstMonthWithoutCompletedMatch &&
			settings.globals.currentMatches[k].year === firstYearWithoutCompletedMatch
		) {
			theK = k;
			stillSearching = false;
		}
	}
	sideText += '<a id="hiddenScrollLink2" href="#bestDate2"></a>';

	// Track dates that have already shown timezone in sidebar
	let sidebarDatesWithTimezone = new Set();

	// Add sticky header at the top (text will be set by setupStickySectionHeader)
	sideText += '<div id="stickySectionHeader" class="sticky-section-header"></div>';

	sideText += '<ul>';
	for (let k = 0; k < settings.globals.currentMatches.length; k++) {
		if (k === theK) sideText += '<a name = "bestDate2"></a>'; //this is the anchor that will auto scroll to
		if (settings.globals.currentTourny.scheduleFormat === 'threeRoundsToThirtyTwoKnockOut') {
			if (k === 0) sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 1</li>';
			else if (k === gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 2</li>';
			else if (k === 2 * gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 3</li>';
			else if (k === 3 * gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Round Of Thirty-Two</li>';
			else if (k === 3 * gamesPerRound + 16)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Round Of Sixteen</li>';
			else if (k === 3 * gamesPerRound + 16 + 8)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Qtr-Finals</li>';
			else if (k === 3 * gamesPerRound + 16 + 8 + 4)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Semi-Finals</li>';
			else if (k === 3 * gamesPerRound + 16 + 8 + 4 + 2)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Final</li>';
		} else if (settings.globals.currentTourny.scheduleFormat === 'threeRoundsToSixteenKnockOut') {
			if (k === 0) sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 1</li>';
			else if (k === gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 2</li>';
			else if (k === 2 * gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 3</li>';
			else if (k === 3 * gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Round Of Sixteen</li>';
			else if (k === 3 * gamesPerRound + 8)
				// qtr final
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Qtr-Finals</li>';
			else if (k === 3 * gamesPerRound + 8 + 4)
				//semi final
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Semi-Finals</li>';
			else if (k === 3 * gamesPerRound + 8 + 4 + 2)
				//final
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Final</li>';
		} else if (settings.globals.currentTourny.scheduleFormat === 'fiveRoundsToEightKnockOut') {
			if (k === 0) sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 1</li>';
			else if (k === gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 2</li>';
			else if (k === 2 * gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 3</li>';
			else if (k === 3 * gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 4</li>';
			else if (k === 4 * gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 5</li>';
			else if (k === 5 * gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Qtr-Finals</li>';
			else if (k === 5 * gamesPerRound + 4)
				//semi final
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Semi-Finals</li>';
			else if (k === 5 * gamesPerRound + 4 + 2)
				//final
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Final</li>';
		} else if (settings.globals.currentTourny.scheduleFormat === 'threeRoundsToEightKnockOut') {
			if (k === 0) sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 1</li>';
			else if (k === gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 2</li>';
			else if (k === 2 * gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Group Stage, Round 3</li>';
			else if (k === 3 * gamesPerRound)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Qtr-Finals</li>';
			else if (k === 3 * gamesPerRound + 4)
				//semi final
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Semi-Finals</li>';
			else if (k === 3 * gamesPerRound + 4 + 2)
				//final
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Final</li>';
		} else if (settings.globals.currentTourny.scheduleFormat === 'leagueToRoundOfTwelveWithByes') {
			if (k === 0) sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Regular Season</li>';
			else if (k === settings.globals.currentTourny.regularSeasonMatches)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Round Of Twelve</li>';
			else if (k === settings.globals.currentTourny.regularSeasonMatches + 6)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Qtr-Finals</li>';
			else if (k === settings.globals.currentTourny.regularSeasonMatches + 6 + 4)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Semi-Finals</li>';
			else if (k === settings.globals.currentTourny.regularSeasonMatches + 6 + 4 + 2)
				sideText += '<li class="nav-item LeftBarTitle"><i class=""></i>Final</li>';
		}
		let theTimeOfGame = null;
		if (!settings.globals.currentMatches[k].matchCompleted)
			// show the time for upcoming games
			theTimeOfGame = settings.globals.currentMatches[k].time;

		// For sidebar: only show timezone for first game on each day
		let dateKey =
			settings.globals.currentMatches[k].year +
			'-' +
			settings.globals.currentMatches[k].month +
			'-' +
			settings.globals.currentMatches[k].day;
		let showTimeZone = false;
		if (theTimeOfGame && !sidebarDatesWithTimezone.has(dateKey)) {
			showTimeZone = true;
			sidebarDatesWithTimezone.add(dateKey);
		}

		theDateOfGame = buildDateForMatch(
			null, //don't include year
			settings.globals.currentMatches[k].month,
			settings.globals.currentMatches[k].day,
			theTimeOfGame,
			true,
			showTimeZone
		);

		dateTimeCode = '<div class="date">' + theDateOfGame + '</div>';
		if (
			k > 0 &&
			settings.globals.currentMatches[k].month === settings.globals.currentMatches[k - 1].month &&
			settings.globals.currentMatches[k].day === settings.globals.currentMatches[k - 1].day
		) {
			if (settings.globals.currentMatches[k].matchCompleted)
				//for same day game, if already played don't show time
				theDateOfGame = '';
			else
				//leave blank
				theDateOfGame = manageData.getCorrectTimeFormat(theTimeOfGame, showTimeZone); //otherwise just show time (but not date)
			dateTimeCode = '<div class="date"><div class="day">' + theDateOfGame + '</div></div>';
		}

		openOfMatch = '<div class="match">'; //open match;
		closeOfMatch = '</div>';

		scoreCode = '<div>' + '<div class="club">'; //open x //open club one

		if (settings.globals.currentMatches[k].teamOneID === 'TBD')
			if (settings.globals.currentMatches[k].teamOneAltText)
				scoreCode += settings.globals.currentMatches[k].teamOneAltText;
			else scoreCode += 'TBD';
		else scoreCode += manageData.getProperEntityName(settings.globals.currentMatches[k].teamOneID);

		scoreCode += '</div>'; //close club one
		scoreCode += buildFlag(settings.globals.currentMatches[k].teamOneID, 'flag', false); // useContainer = false to hide country name in sidebar
		scoreCode +=
			'<div class="score">' + //open score one
			showBlankOrScore(settings.globals.currentMatches[k], 1) +
			'</div>' + //close score one
			'</div>' + //close  x
			'<div>' + //open y
			'<div class="club">'; //open club 2
		if (settings.globals.currentMatches[k].teamTwoID === 'TBD')
			if (settings.globals.currentMatches[k].teamTwoAltText)
				scoreCode += settings.globals.currentMatches[k].teamTwoAltText;
			else scoreCode += 'TBD';
		else scoreCode += manageData.getProperEntityName(settings.globals.currentMatches[k].teamTwoID);
		scoreCode += '</div>'; //close club 2
		scoreCode += buildFlag(settings.globals.currentMatches[k].teamTwoID, 'flag', false); // useContainer = false to hide country name in sidebar
		scoreCode +=
			'<div class="score">' + //open score 2
			showBlankOrScore(settings.globals.currentMatches[k], 2) +
			'</div>';
		+//close score 2
			'</div>'; // close y

		openOfButton = '<div class="sideBarFormat">';
		closeOfButton = '</div>';

		allTogetherCode = openOfButton + dateTimeCode + openOfMatch + scoreCode + closeOfMatch + closeOfButton;
		if (settings.globals.currentMatches[k].matchCompleted && settings.globals.currentMatches[k].youTubeID) {
			//||settings.globals.currentMatches[k].sportMonksVideoLink)

			//|| settings.globals.currentTourny.buildVideoLink)
			// if there is a video add it
			allTogetherCode += videoButtonCodeOpen + settings.globals.currentMatches[k].matchID + videoButtonCodeClose; //+
			//'</a>';
		}

		sideText += '<li class="nav-item">';
		sideText += allTogetherCode;
		sideText += '</li>';
	}
	sideText += '</ul>';
	leftBar.innerHTML = sideText;

	// Initialize sticky section header
	setupStickySectionHeader();

	// Scroll to top (first match) instead of scrolling to first incomplete match
	setTimeout(function () {
		const leftBarContainer = document.getElementById('LeftBarContainer');
		if (leftBarContainer) {
			leftBarContainer.scrollTop = 0;
		}
	}, 200);
}

function buildSideBarPicsForCurrentTeam() {
	buildSideBarPics(settings.globals.currentTeamID);
}

function buildSideBarPicsForCurrentFromCountry() {
	buildSideBarPics(settings.globals.currentFromEntityID);
}

/**
 * @param teamID
 * @returns {string}
 */
function buildSideBarPics(teamID) {
	let thePlayers = settings.globals.currentPlayersInTourny.filter((m) => m.playsForID === teamID);
	let len = thePlayers.length;
	if (len === 0) {
		utilities.myErrorReport('location 10 ' + 'no players  found when making pics', settings.misc.majorError);
	} else {
		let sideText = '';
		let playersSortedByName = [];
		sideText += '<div  class="players_cont"><div style="touch-action: pan-y;" class="players">';
		for (let k = 0; k < len; k++) {
			let thePlayer = settings.globals.players.find((z) => z.playerID === thePlayers[k].playerID);
			if (thePlayer === undefined) {
				utilities.myErrorReport(
					'location 20 ' + 'player not found when searching by ID: ' + thePlayers[k].playerID,
					settings.misc.majorError
				);
			} else {
				playersSortedByName.push([
					manageData.getProperPlayerName(thePlayer, teamID),
					thePlayer.playerID,
					thePlayer.imagePath
				]);
			}
		}
		// playersSortedByName.sort((a, b) => utilities.mySort(a, b));
		playersSortedByName.sort((a, b) => {
			const nameA = a[0] || '';
			const nameB = b[0] || '';
			return nameA.localeCompare(nameB, 'en', { sensitivity: 'base' });
		});
		for (let k = 0; k < playersSortedByName.length; k++) {
			sideText += '<a class="sideBarFormat';
			if (k === 0) sideText += ' active ';
			sideText += ' player player-' + (k + 1) + '"data-playerID="' + playersSortedByName[k][1]; //PlayerID is stored here
			if (playersSortedByName[k][2]) {
				//if there is a URL to the pic
				sideText +=
					'" href="#"><div class="img" style="background-image: url(\'' + //this is where the pic is added. it is in the [k][2]
					playersSortedByName[k][2] +
					"') " +
					'">' +
					'</div >';
			} else {
				sideText +=
					'" href="#"><div class="img" style="background-image: url(\'' +
					settings.globals.currentTourny.picURL +
					playersSortedByName[k][1].substr(6, playersSortedByName[k][1].length - 6) + //this is a hack to remove the word legacy from the id
					settings.globals.currentTourny.picsSuffix +
					"') " +
					'">' +
					'</div >';
			}
			// Break name on first space - wrap second part to next line
			let playerName = playersSortedByName[k][0];
			let nameWithBreak = playerName;
			if (playerName && playerName.indexOf(' ') !== -1) {
				// Replace first space with <br> tag
				nameWithBreak = playerName.replace(' ', '<br>');
			}
			sideText += '<div class="player-name">' + nameWithBreak + '</div></a>';
		}
		sideText += '</div></div>';
		leftBar.innerHTML = '';
		leftBar.innerHTML +=
			'<div class="players_team_title"><h2>' + manageData.getProperEntityName(teamID) + '</h2></div>';
		leftBar.innerHTML += sideText;
		addSidePicsClickHandler(teamID);

		// Reset scroll position to top when new country is selected
		if (menu) {
			menu.scrollTop = 0;
		}
	}
}

function addHeaderActiveClass() {
	let headerDiv = document.getElementById('HeaderTable');
	let current = headerDiv.getElementsByClassName('active');
	let currentDropdowns = headerDiv.getElementsByClassName('dropdown_main');

	function clearActives() {
		while (current.length > 0) {
			//keep checking length because the array of active elements gets updated after each remove
			current[0].classList.remove('active'); //make everything inactive before adding one back
		}
	}

	function clearAddedNames() {
		for (let k = 0; k < currentDropdowns.length; k++) {
			if (currentDropdowns[k].classList.contains('tourny_selectorBase')) {
				// do nothing, i.e don't clear the tourny
			} else currentDropdowns[k].setAttribute('data-addname', ''); // clear it //clear everything before adding one back
		}
	}

	let headerTable = document.getElementById('HeaderTable');
	if (headerTable) {
		let btns = headerTable.getElementsByClassName('nav-item');
		for (let i = 0; i < btns.length; i++) {
			btns[i].addEventListener('click', function (e) {
				e.preventDefault();

				let baseName = '';
				let menuSelected = e.target.innerHTML; // the menu that was clicked
				if (this.classList.contains('dropdown')) {
					if (e.target.classList.contains('dropdown-item')) {
						//handle dropdowns like this...

						baseName = this.children[0].getAttribute('data-basename');
						for (let k = 0; k < currentDropdowns.length; k++) {
							if (currentDropdowns[k].classList.contains('tourny_selectorBase')) {
								// do nothing, i.e don't clear the tourny
							} else currentDropdowns[k].setAttribute('data-addname', ''); // clear it //clear everything before adding one back
						}
						clearAddedNames();
						this.children[0].setAttribute('data-addname', menuSelected);
						clearActives();
						this.classList.add('active');
					}
				} else {
					clearAddedNames();
					clearActives();
					this.classList.add('active'); // not a dropdown
				}
				if (
					!this.classList.contains('dropdown') ||
					(this.classList.contains('dropdown') && e.target.classList.contains('dropdown-item'))
				) {
					let navOpen = document.querySelector('html').getAttribute('data-mobile_nav_open');
					let theText = '';
					if (navOpen === 'false') {
						theText = 'OneWorld-Futbol';
					} else {
						if (baseName === '')
							// just add the menu selected
							theText += menuSelected;
						else
							// add the base name and the menu selected
							theText += baseName + ': ' + menuSelected;
					}
					document.getElementById('siteTitleLineThree').innerHTML = theText;

					//document.querySelector('.world_cup_selectorBase').setAttribute('data-addname', theText);
				}
				document.getElementById('siteTitleLineFour').innerHTML = settings.globals.currentTourny.menuName;
				//only bounce out of mobile menu if choosing a legit menu-item
				document.querySelector('html').setAttribute('data-mobile_nav_open', 'false');
			});
		}
	}
}

function addSideBarActiveClass() {
	if (leftBar) {
		let btnsLeftBar = leftBar.getElementsByClassName('nav-item');
		for (let i = 0; i < btnsLeftBar.length; i++) {
			btnsLeftBar[i].addEventListener('click', function () {
				// let temp = leftBar;
				let activeButtons = leftBar.getElementsByClassName('active');
				while (
					activeButtons.length > 0 //keep checking length because the array of active elements gets update after each remove
				)
					activeButtons[0].classList.remove('active');
				this.classList.add('active');
			});
		}
	}
}

/**
 * Highlight the menu item that corresponds to a given layer index.
 * This is used when switching layers programmatically (not via menu click).
 * @param {number} layerIndex - The layer index to highlight
 */
function highlightMenuForLayer(layerIndex) {
	const headerDiv = document.getElementById('HeaderTable');
	if (!headerDiv) return;

	// Find all nav-items (including dropdowns)
	const navItems = headerDiv.getElementsByClassName('nav-item');

	// Build the search string for the layer index (e.g., "settings.layerIndices.helpLayerIndex")
	// We need to find which property name corresponds to this layerIndex
	let layerIndexName = null;
	for (const key in settings.layerIndices) {
		if (settings.layerIndices[key] === layerIndex) {
			layerIndexName = key;
			break;
		}
	}
	if (!layerIndexName) return; // Couldn't find the layer index name

	const searchString = `settings.layerIndices.${layerIndexName}`;

	// Find the menu item that has onclick="switchModes(...)" with our layer index
	for (let i = 0; i < navItems.length; i++) {
		const navItem = navItems[i];

		// Check if this nav-item directly calls switchModes with our layer index
		const onclickAttr = navItem.getAttribute('onclick');
		if (onclickAttr && onclickAttr.includes(searchString)) {
			// Direct nav-item (not dropdown)
			clearHeaderActives(headerDiv);
			navItem.classList.add('active');
			// Update mobile menu title
			const siteTitleLineThree = document.getElementById('siteTitleLineThree');
			if (siteTitleLineThree) {
				siteTitleLineThree.innerHTML = navItem.textContent.trim();
			}
			return;
		}

		// Check dropdown items
		if (navItem.classList.contains('dropdown')) {
			const dropdownItems = navItem.querySelectorAll('.dropdown-item');
			for (let j = 0; j < dropdownItems.length; j++) {
				const dropdownItem = dropdownItems[j];
				const itemOnclick = dropdownItem.getAttribute('onclick');
				if (itemOnclick && itemOnclick.includes(searchString)) {
					// Found the dropdown item - highlight its parent dropdown
					clearHeaderActives(headerDiv);
					navItem.classList.add('active');
					// Set the dropdown's data-addname to show the selected item
					const dropdownMain = navItem.querySelector('.dropdown_main');
					if (dropdownMain) {
						dropdownMain.setAttribute('data-addname', dropdownItem.textContent.trim());
					}
					// Update mobile menu title
					const siteTitleLineThree = document.getElementById('siteTitleLineThree');
					if (siteTitleLineThree) {
						const baseName = dropdownMain ? dropdownMain.getAttribute('data-basename') : '';
						const menuSelected = dropdownItem.textContent.trim();
						siteTitleLineThree.innerHTML = baseName ? baseName + ': ' + menuSelected : menuSelected;
					}
					return;
				}
			}
		}
	}
}

/**
 * Clear all active classes from header menu items
 */
function clearHeaderActives(headerDiv) {
	const current = headerDiv.getElementsByClassName('active');
	while (current.length > 0) {
		current[0].classList.remove('active');
	}
	// Also clear data-addname from dropdowns (except tournament selector)
	const currentDropdowns = headerDiv.getElementsByClassName('dropdown_main');
	for (let k = 0; k < currentDropdowns.length; k++) {
		if (!currentDropdowns[k].classList.contains('tourny_selectorBase')) {
			currentDropdowns[k].setAttribute('data-addname', '');
		}
	}
}

/**
 * @param baseEntityID
 * @param destinationEntityID
 */
function addPicsGroupActiveClass(baseEntityID, destinationEntityID) {
	let thePlayers = settings.globals.currentPlayersInTourny.filter((o) => o.playsForID === baseEntityID);
	if (thePlayers.length === 0) {
		utilities.myErrorReport(
			'location 40 ' + 'no players found for marker base entity: ' + baseEntityID,
			settings.misc.majorError
		);
	} else {
		if (leftBar) {
			let btnsLeftBar = leftBar.getElementsByClassName('player');
			for (let i = 0; i < btnsLeftBar.length; i++) {
				btnsLeftBar[i].classList.remove('active'); //highlight the button, could be several
				for (let k = 0; k < thePlayers.length; k++) {
					let theClub = settings.globals.clubs.find(
						(g) => g.clubID === thePlayers[k].clubID && g.clubLocationID === destinationEntityID
					);
					if (theClub === undefined) {
						// do nothing if the club isn't found
					} else {
						//if (thePlayers[k].playerID === parseInt(btnsLeftBar[i].getAttribute('data-playerID'))) {
						if (thePlayers[k].playerID == btnsLeftBar[i].getAttribute('data-playerID')) {
							// purposely using == because legacy IDs are strings whereas API
							btnsLeftBar[i].classList.add('active'); //highlight the button, could be several
						}
					}
				}
			}
		}
	}
}

function addSidePicsClickHandler(teamID) {
	if (leftBar) {
		let picBtnsLeftBar = leftBar.getElementsByClassName('player');
		for (let i = 0; i < picBtnsLeftBar.length; i++) {
			picBtnsLeftBar[i].addEventListener('click', function () {
				let activeButtons = leftBar.getElementsByClassName('active');
				// note activeButtons gets dynamically changed with each removal.  so that is why i have to check the length over and over
				while (activeButtons.length > 0) {
					activeButtons[0].classList.remove('active');
				}
				this.classList.add('active');
				activeButtons = leftBar.getElementsByClassName('active');
				//let playerID = parseInt(this.getAttribute('data-playerID'));
				let playerID = this.getAttribute('data-playerID');
				// Filter by both playerID and playsForID to handle cases where a player appears on multiple teams
				let thePlayerInTourny = settings.globals.currentPlayersInTourny.find(
					(m) => m.playerID == playerID && m.playsForID == teamID
				); //// purposely using == because legacy IDs are strings whereas API
				if (thePlayerInTourny === undefined) {
					utilities.myErrorReport(
						'location 50 ' + 'player not found when clicking on pic: ',
						playerID,
						settings.misc.majorError
					);
				} else {
					let player = settings.globals.players.find((k) => k.playerID === thePlayerInTourny.playerID);
					let playerClub = settings.globals.clubs.find((k) => k.clubID === thePlayerInTourny.clubID);
					if (player === undefined)
						utilities.myErrorReport(
							'location 60 ' + 'undefined not found when clicking on pic',
							settings.misc.majorError
						);
					else {
						let theLocationToUse = '';
						if (playerClub === undefined) theLocationToUse = teamID;
						else if (
							settings.globals.currentTourny.tournyID === 'EPL2022' ||
							settings.globals.currentTourny.tournyID === 'MLS2022'
						) {
							// For EPL/MLS, use the club's own entity ID (stadium location)
							theLocationToUse = thePlayerInTourny.clubID;
						} else {
							// For other tournaments, use clubLocationID (country code for country centroid)
							theLocationToUse = playerClub.clubLocationID;
						}
						let entityOfClub = settings.fifaEntities.find((m) => m.ID === theLocationToUse);
						if (entityOfClub === undefined)
							utilities.myErrorReport(
								'location 70 ' + 'undefined entity when clicking on pic',
								settings.misc.majorError
							);
						else {
							let theNationality = null;
							if (settings.globals.currentTourny.showNationality) theNationality = player.nationality;
							console.log(thePlayerInTourny);
							L.popup(settings.generalPopUpStyle)
								.setLatLng([entityOfClub.latitude, entityOfClub.longitude])
								.setContent(
									buildIndividualPlayerPopUp(
										manageData.getProperEntityName(theLocationToUse),
										manageData.getProperClubName(playerClub),
										player.name,
										utilities.calculateAge(
											player.birthMonth,
											player.birthDay,
											player.birthYear,
											settings.globals.currentTourny.startMonth,
											settings.globals.currentTourny.startDay,
											settings.globals.currentTourny.startYear
										),
										thePlayerInTourny.position,
										thePlayerInTourny.jerseyNumber,
										thePlayerInTourny.caps,
										thePlayerInTourny.goals,
										player.height,
										player.weight,
										theNationality
									)
								)
								.openOn(settings.globals.map);
						}
					}
				}
			});
		}
	}
}

function replaceUserDependentMenu() {
	//document.getElementById('userDependentMenu').innerHTML = buildUserDependentMenu();
}

function buildHeader() {
	let tournyID = settings.globals.currentTourny.tournyID;
	let text = '';
	const theIndex = settings.tournys.findIndex((v) => v.tournyID === tournyID);

	text += '<div class="nonChangingPartOfHeader">'; //open div nonChangingPartOfHeader
	text += '<div id="siteTitleLineOne" class="siteTitle siteTitleShowOppositeOfHamburger">OneWorld-Futbol</div>';
	text += '<div id="siteTitleLineThree" class="siteTitle siteTitleShowLikeHamburger">Schedule</div>';
	text +=
		'<div id="siteTitleLineFour" class="siteTitle siteTitleShowLikeHamburger">' +
		settings.globals.currentTourny.menuName +
		'</div>';
	text += '<div id="HeaderTable2">'; //open div id HeaderTable2
	text += '</div>'; //close id HeaderTable2
	text += '</div>'; //close div nonChangingPartOfHeader

	text += '<div class="changingPartOfHeader">'; //open div changingPartOfHeader
	text += '<ul id = "HeaderTable">'; //open ul id HeaderTable

	// Use the new menu system
	text += buildMenuSections();

	text += '</ul>'; //close ul id HeaderTable
	text += '</div>'; //close changingPartOfHeader
	text += '<div class="hamburger">'; //open div hamburger
	text += '<div class="menu_text">'; //open div menu_text
	text += '<span class="menu1"></span>'; //was 'menu', no text needed the 'X' is sufficeint
	text += '<span class="menu2"></span>'; //was 'close', no text needed the 'X' is sufficeint
	text += '</div>'; //close menu_text
	text += '<div class="nav_burger">'; //open div nav_burger
	text += '<div></div>';
	text += '<div></div>';
	text += '<div></div>';
	text += '</div>'; //close nav_burger
	text += '</div>'; // close hamburger
	return text;
}

/**
 * @returns {string}
 * this builds all the code for the menu bar
 */

function buildDateForMatchOLD(year, month, day, time, twoLine) {
	let theReturnText = ''; //; '<div class="date">';
	if (time) {
		theReturnText += manageData.getCorrectTimeFormat(time);
		if (twoLine) theReturnText += '<br>';
		else theReturnText += ',&nbsp';
	}
	if (month) theReturnText += settings.months[month].shortName + '&nbsp';
	if (day) theReturnText += day + '&nbsp';
	if (year) theReturnText += year;
	return theReturnText;
}

function buildDateForMatch(year, month, day, time, twoLine, showTimeZone = true) {
	let theReturnText = '';
	if (twoLine) {
		if (month) theReturnText += settings.months[month].shortName + '&nbsp';
		if (day) theReturnText += day + '&nbsp';
		if (year) theReturnText += year;
		theReturnText += '<br>';
		if (time) {
			theReturnText += manageData.getCorrectTimeFormat(time, showTimeZone);
		}
	} else {
		if (month) theReturnText += settings.months[month].shortName + '&nbsp';
		if (day) theReturnText += day + '&nbsp';
		if (year) theReturnText += year;
		if (time) {
			theReturnText += ',&nbsp';
			theReturnText += manageData.getCorrectTimeFormat(time, showTimeZone);
		}
	}
	return theReturnText;
}

function buildGroupPopUp(theEntityDisplayName, theGroupStandings, entityID = null) {
	let returnText = '';
	if (entityID) returnText = buildFlag(entityID);
	return returnText + theGroupStandings;
}

function buildGroupPopUpBody(groupName, teamsInGroup) {
	let html = '';
	let i = 0;
	let len = teamsInGroup.length;
	let first_char = ['W', 'L', 'T', 'P', 'GF', 'GA', 'GD'];
	// If group only has 3 teams, add TBD at the end
	let showTBD = len === 3;

	html += '<div class="group_table">';
	html += '<div>';
	html += '<div class="first">' + groupName + '</div>';
	for (i = 0; i < len; i++) {
		html += '<div class="firstColumn">' + manageData.getProperEntityName(teamsInGroup[i].ID) + '</div>';
	}
	if (showTBD) {
		html += '<div class="firstColumn">TBD</div>';
	}
	html += '</div>';
	html += '<div>';
	html += '<div>';
	html += '<div class="first">' + first_char[0] + '</div>';
	for (i = 0; i < len; i++) {
		html += '<div>' + teamsInGroup[i].groupStageWins + '</div>';
	}
	if (showTBD) {
		html += '<div>0</div>';
	}
	html += '</div>';
	html += '<div>';
	html += '<div class="first">' + first_char[1] + '</div>';
	for (i = 0; i < len; i++) {
		html += '<div>' + teamsInGroup[i].groupStageLosses + '</div>';
	}
	if (showTBD) {
		html += '<div>0</div>';
	}
	html += '</div>';
	html += '<div>';
	html += '<div class="first">' + first_char[2] + '</div>';
	for (i = 0; i < len; i++) {
		html += '<div>' + teamsInGroup[i].groupStageTies + '</div>';
	}
	if (showTBD) {
		html += '<div>0</div>';
	}
	html += '</div>';
	html += '<div>';
	html += '<div class="first">' + first_char[3] + '</div>';
	for (i = 0; i < len; i++) {
		html += '<div>' + teamsInGroup[i].groupStagePoints + '</div>';
	}
	if (showTBD) {
		html += '<div>0</div>';
	}
	html += '</div>';
	html += '<div>';
	html += '<div class="first">' + first_char[4] + '</div>';
	for (i = 0; i < len; i++) {
		html += '<div>' + teamsInGroup[i].groupStageGoalsFor + '</div>';
	}
	if (showTBD) {
		html += '<div>0</div>';
	}
	html += '</div>';
	html += '<div>';
	html += '<div class="first">' + first_char[5] + '</div>';
	for (i = 0; i < len; i++) {
		html += '<div>' + teamsInGroup[i].groupStageGoalsAgainst + '</div>';
	}
	if (showTBD) {
		html += '<div>0</div>';
	}
	html += '</div>';
	html += '<div>';
	html += '<div class="first">' + first_char[6] + '</div>';
	for (i = 0; i < len; i++) {
		html += '<div>' + teamsInGroup[i].groupStageGoalDifferential + '</div>';
	}
	if (showTBD) {
		html += '<div>0</div>';
	}
	html += '</div>';
	html += '</div>';
	html += '</div>';

	return html;
}

function buildFromCountryMarkersPopUpTitle(location, adjective, tournyName) {
	return (
		'<div class="super_title"><strong>Clubs</strong>' +
		' in ' +
		location +
		' with ' +
		myBold(adjective) +
		'&nbsp' +
		'<br>' +
		tournyName +
		' Players:<div>'
	);
}
function buildFromCountryMarkersPopUpBody(entries) {
	let returnText = '<table>';
	for (let theEntry of entries) {
		returnText += '<tr><td>' + myBold(theEntry[0]) + '</td><td>' + theEntry[1] + '</td></tr>';
	}
	returnText += '</table>';
	return returnText;
}

function buildFromCountryMarkersPopUp(location, adjective, entries, tournyName, entityID = null) {
	return (
		buildFromCountryMarkersPopUpTitle(location, adjective, tournyName) +
		'<br>' +
		buildFromCountryMarkersPopUpBody(entries)
	);
}

function buildToCountryMarkersPopUpTitle(location, adjective, tournyName) {
	return (
		'<div class="super_title">' +
		myBold(adjective) +
		'&nbsp' +
		tournyName +
		' Players on ' +
		myBold('Clubs') +
		'<br>' +
		' in ' +
		location +
		':' +
		'<div>'
	);
}

function buildQualifyingHistoryPopUpBody(entries) {
	let returnText = '<table class="qualifyHistoryTable">';
	for (let theEntry of entries) {
		returnText +=
			'<tr>' +
			'<td>' +
			buildDateForMatch(null, theEntry[1], theEntry[2], null, false) + // don't include year or time
			'</td>' +
			'<td>' +
			theEntry[3] +
			'</td>' +
			'<td>' +
			theEntry[4] +
			'</td>' +
			'</tr>' +
			'<tr>' +
			'<td>' +
			'</td>' +
			'<td>' +
			theEntry[5] +
			'</td>' +
			'<td>' +
			theEntry[6] +
			'</td>' +
			'</tr>' +
			'<tr>' +
			'<td>' +
			'<br />' +
			'</td>' +
			'</tr>';
	}
	return (returnText += '</table>');
}

function buildToCountryMarkersPopUpBody(entries) {
	let returnText = '';
	for (let theEntry of entries) {
		returnText += '<tr><td>' + theEntry[1] + '</td><td>' + myBold(theEntry[0]) + '</td></tr>';
	}
	return returnText;
}

function buildToCountryMarkersPopUp(location, adjective, entries, tournyName) {
	return (
		'<table>' +
		buildToCountryMarkersPopUpTitle(location, adjective, tournyName) +
		'<br>' +
		buildToCountryMarkersPopUpBody(entries) +
		'</table>'
	);
}
/**
 * @param baseEntityID
 * @param markerEntityID
 * @returns {string}
 */

function buildFanMarkersPopUp(countryName, theCityName, fanCount, entityID = null) {
	let returnText = '';
	if (entityID) returnText = buildFlag(entityID);
	return returnText + theCityName + '<br>' + fanCount + ' Fans using this site!';
}

function handleCoffee() {
	window.open(settings.misc.coffeeLink, '_blank');
}

function handlePrivacy() {
	window.open(settings.misc.privacyLink, '_blank');
}

function handleTerms() {
	window.open(settings.misc.termsLink, '_blank');
}

function handleSendEmail() {
	window.open(settings.misc.emailLink, '_blank');
}

/**
 * For simplicity sake, all layers are dumped from the map,
 * each time a new layer is displayed.
 * That way, I don't have to keep track of which layers are on display.
 * (Sometimes more than one layer is on display.)
 */
function dumpLayers() {
	//remove all layers
	// COMMENTED OUT: Previous version assumed map always exists
	// Previously: Called eachLayer without checking if map exists
	// settings.globals.map.eachLayer(function (layer) {
	//     settings.globals.map.removeLayer(layer);
	// });
	// NEW: Check if map exists before trying to remove layers (map may not be initialized yet during login flow)
	if (settings.globals.map) {
		settings.globals.map.eachLayer(function (layer) {
			settings.globals.map.removeLayer(layer);
		});
	}

	//remove all legends, add back as necessary
	// COMMENTED OUT: Previous version assumed map always exists
	// Previously: Called removeControl without checking if map exists
	// for (const legendControl of settings.globals.legendControls) {
	//     if (legendControl) settings.globals.map.removeControl(legendControl);
	// }
	// NEW: Check if map exists before removing controls
	if (settings.globals.map) {
		for (const legendControl of settings.globals.legendControls) {
			if (legendControl) settings.globals.map.removeControl(legendControl);
		}
	}

	for (const sliderControl of settings.globals.sliderControls) {
		if (sliderControl) settings.globals.map.removeControl(sliderControl);
	}

	manageData.setAttributesFalse();
}

function bringInDataViz() {
	leftBar.innerHTML = '';
}

function buildPrivacy() {
	let returnText = '<div class="generalTextDisplay">';
	returnText += 'Thank you for reading our Privacy Policy.';
	returnText += '</div>';
	leftBar.innerHTML = returnText;
}

function buildTerms() {
	let returnText = '<div class="generalTextDisplay">';
	returnText += 'Thank you for reading our Terms Of Use.';
	returnText += '</div>';
	leftBar.innerHTML = returnText;
}

function buildSubscribe() {
	let returnText =
		'<div class="generalTextDisplay">' +
		'<div id="mySpinner">' +
		'</div>' +
		'<div id="myFirebaseUI-Container">' +
		// Custom email/password sign-in form (sign-in only, no sign-up)
		'<div id="custom-email-password-login">' +
		'<h3><span style="color: #aa1110; font-weight: bold;">OneWorld-Futbol</span><br>Evaluation System</h3>' +
		'<div id="custom-login-error"></div>' +
		'<form id="custom-login-form">' +
		'<input type="email" id="custom-login-email" placeholder="Email" required>' +
		'<input type="password" id="custom-login-password" placeholder="Password" required>' +
		'<button type="submit">Sign In</button>' +
		'</form>' +
		'<p class="login-contact-info" style="margin-top: 1em;">For more info or to extend your evaluation period contact:<br><a href="mailto:info@OneWorld-Futbol.com" class="login-contact-email-link">info@OneWorld-Futbol.com</a></p>' +
		'</div>' +
		// FirebaseUI container for other providers (e.g., Google) if configured
		'<section id="firebaseui-auth-container">' +
		'</section>' +
		'</div>' +
		'<div>' +
		'<div id="subscribe">' +
		'Advanced Features' +
		'<br>' +
		'<div id="bulletList">' +
		'• Major League Soccer<br>' +
		'• English Premeire League<br>' +
		'• World Cup 2022<br>' +
		'• Womens World Cup 2023<br>' +
		'• Talent Flow<br>' +
		'• Videos<br>' +
		'• Insights<br><br>' +
		'<div>' +
		'<section class="products">' +
		'</section > ' +
		'</div>' +
		'<div>' +
		'<p>' +
		'</p > ' +
		'</div>' +
		'<template id="product">' +
		'<div class="product">' +
		'<div class="description">description' +
		'</div > ' +
		'<form class="product-form">' +
		'<select id="price" name="price">' +
		'</select > ' +
		'<button id="mySubscribeButton" type="submit">Subscribe' +
		'</button>' +
		'</form>' +
		'</div>' +
		'</template>' +
		'<link' +
		'type="text/css"' +
		'rel = "stylesheet"' +
		'href="https://cdn.firebase.com/libs/firebaseui/3.5.2/firebaseui.css"' +
		'/>';
	'</div>' + '</div>';
	leftBar.innerHTML = returnText;
}

function buildCoffee() {
	let returnText = '<div class="generalTextDisplay">';
	returnText += 'Thank you for the coffee!';
	returnText += '</div>';
	leftBar.innerHTML = returnText;
}

function addLayerAndExtras(whichLayerIndex) {
	// COMMENTED OUT: Previous version assumed map always exists
	// Previously: Called map methods without checking if map is initialized
	// NEW: Check if map exists before proceeding (map may not be initialized yet during login flow)
	if (!settings.globals.map) {
		console.warn('Map not initialized yet, cannot add layer. Layer index:', whichLayerIndex);
		// If map isn't initialized, this might be called too early in the login flow
		// Return early and let the initialization complete first
		return;
	}

	// NEW: Clear inline styles from LeftBarContainer that were set during login
	// These inline styles (width: 100%, etc.) can interfere with layer-specific CSS rules
	// Layer-specific rules (like data-dashboard_layer) should control the leftbar styling
	const leftBarContainer = document.getElementById('LeftBarContainer');
	if (leftBarContainer) {
		// Only clear styles if we're switching to a layer that has its own leftbar styling
		// Don't clear if we're going to subscribe/login layer (which needs full width)
		if (whichLayerIndex !== settings.layerIndices.subscribeLayerIndex) {
			leftBarContainer.style.width = '';
			leftBarContainer.style.display = '';
			leftBarContainer.style.opacity = '';
			leftBarContainer.style.position = '';
			leftBarContainer.style.zIndex = '';
			// Let CSS handle the styling based on data attributes
		}
	}

	//if necessary buildLeftBar
	if (settings.globals.layerParameters[whichLayerIndex].leftBarFunction) {
		settings.globals.layerParameters[whichLayerIndex].leftBarFunction();
	} else leftBar.innerHTML = '';

	//if necessary run a function for that layer
	if (settings.globals.layerParameters[whichLayerIndex].auxillaryFunction) {
		settings.globals.layerParameters[whichLayerIndex].auxillaryFunction();
	}

	//if necessary add an attribute
	if (settings.globals.layerParameters[whichLayerIndex].auxillaryAttributes) {
		for (const attribute of settings.globals.layerParameters[whichLayerIndex].auxillaryAttributes) {
			document.querySelector('html').setAttribute(attribute, 'true');
		}
	}

	//add the layer
	settings.globals.layers[whichLayerIndex].addTo(settings.globals.map);

	//if necessary add labels
	if (settings.globals.layerParameters[whichLayerIndex].labels) {
		settings.globals.layers[settings.globals.layerParameters[whichLayerIndex].labels].addTo(settings.globals.map);
	}
	//if necessary add a slider
	if (settings.globals.layerParameters[whichLayerIndex].sliderControlIndex) {
		settings.globals.sliderControls[settings.globals.layerParameters[whichLayerIndex].sliderControlIndex].addTo(
			settings.globals.map
		);
	}

	//if necessary add an auxillary layer
	if (settings.globals.layerParameters[whichLayerIndex].auxillaryLayerIndex) {
		settings.globals.map.addLayer(
			settings.globals.layers[settings.globals.layerParameters[whichLayerIndex].auxillaryLayerIndex]
		);
	}

	//if necessary add legend
	let addTheLegend = false;
	if (settings.globals.layerParameters[whichLayerIndex].legendControlIndex) {
		if (
			settings.globals.layerParameters[whichLayerIndex].legendControlIndex ===
			settings.legendControlIndices.confederationIndex ||
			settings.globals.layerParameters[whichLayerIndex].legendControlIndex ===
			settings.legendControlIndices.qualifyingIndex
		) {
			// Check if it's a world tournament (all 6 confederations)
			let isWorldTourny = false;
			if (settings.globals.currentTourny.allowedConfederationIDs) {
				// World tournament has all 6 confederations
				isWorldTourny =
					settings.globals.currentTourny.allowedConfederationIDs.length === 6 &&
					settings.globals.currentTourny.allowedConfederationIDs.includes(1) &&
					settings.globals.currentTourny.allowedConfederationIDs.includes(2) &&
					settings.globals.currentTourny.allowedConfederationIDs.includes(3) &&
					settings.globals.currentTourny.allowedConfederationIDs.includes(4) &&
					settings.globals.currentTourny.allowedConfederationIDs.includes(5) &&
					settings.globals.currentTourny.allowedConfederationIDs.includes(6);
			} else {
				// Fallback for backward compatibility
				isWorldTourny = settings.globals.currentTourny.confederationID === 0;
			}
			if (isWorldTourny) {
				//for qualifying or confederation legends, only add for a worldwide tourny
				addTheLegend = true;
			}
		} else addTheLegend = true;
	}
	if (addTheLegend)
		settings.globals.legendControls[settings.globals.layerParameters[whichLayerIndex].legendControlIndex].addTo(
			settings.globals.map
		);

	const mapDiv = document.getElementById('map');
	const resizeObserver = new ResizeObserver(() => {
		settings.globals.map.invalidateSize();
	});
	resizeObserver.observe(mapDiv);
	setTimeout(() => {
		settings.globals.map.fitBounds(manageData.getRegionBounds(whichLayerIndex));
	}, 200);
}

function buildLegend(entries, title) {
	let returnText = '<div class="legendTitle" style="padding-bottom: 3px;">' + title + '</div>';
	for (const entry of entries) {
		if (entry.altShape === 'dot')
			returnText +=
				'<span i style="background: ' +
				entry.color +
				'"class="legendDot"></span><span>' +
				entry.text +
				'</span><br>';
		else if (entry.altShape === 'circle')
			returnText +=
				'<span i style="background: ' +
				'#FFFFFF' +
				'"class="legendCircle"></span><span>' +
				entry.text +
				'</span><br>';
		else {
			returnText += '<i style="background: ' + entry.color + '"></i><span>' + entry.text;
			returnText += '<div class="legendPlainText">' + ' ' + entry.textPartTwo + '</div>';
			returnText += '</br>';
		}
	}
	return returnText;
}

function buildNoGreatPlayerPopUp(hostName, entityID = null) {
	let returnText = '';
	if (entityID) returnText = buildFlag(entityID);
	return returnText + 'No players included yet.';
}

function buildNoHostPopUp(hostName, typeOfHost, entityID = null) {
	let returnText = '';
	if (entityID) returnText = buildFlag(entityID);
	return returnText + 'Has never hosted a ' + typeOfHost + '.';
}

function buildHostPopUp(hostArray, typeOfHost, entityID = null) {
	let theReturnText = '';
	if (entityID) {
		const hostLabel = 'Host: ' + hostArray[0].hostOriginalName;
		const sublabel = hostArray.length > 1 ? hostArray.length + ' videos' : null;
		theReturnText = buildFlag(entityID, 'flag', true, hostLabel, sublabel);
	}
	for (const entry of hostArray) {
		theReturnText += '<div>';
		theReturnText += myBold(typeOfHost + ' Final, ') + myBold(entry.year) + '</div>';
		theReturnText +=
			'<div>' +
			entry.firstPlaceOriginalName +
			' ' +
			entry.firstPlaceScore +
			' - ' +
			entry.secondPlaceOriginalName +
			' ' +
			entry.secondPlaceScore +
			'</div>';
		if (entry.pks === true) theReturnText += '<div>*Game won on penalty kicks.<br><br></div>';
		else theReturnText += '<div><br></div>';
		if (entry.youTubeID) {
			let videoLink = settings.misc.embedCode + entry.youTubeID;
			theReturnText +=
				'<div><iframe width="305" height="162" src=' +
				'"' +
				videoLink +
				'"' +
				' frameborder="0" allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>' +
				'</iframe>' +
				'</div>';
		}
		theReturnText += '<div><br></div>';
	}
	return theReturnText;
}

function buildGreatPlayerPopUp(playerArray, playedForCountry, entityID = null) {
	//not all great players are in allPlayers. so, their birthday info is recored in gretPlayers.json
	let theReturnText = '';
	if (entityID) {
		const sublabel = playerArray.length > 1 ? playerArray.length + ' videos' : null;
		theReturnText = buildFlag(entityID, 'flag', true, null, sublabel);
	}
	let theName = '';
	for (const entry of playerArray) {
		theReturnText += '<div>';
		if (entry.lastName) theName = entry.firstName + ' ' + entry.lastName;
		else theName = entry.firstName;
		theReturnText += myBold(theName) + ',&nbspBirthday: ';
		theReturnText += entry.birthDay + '&nbsp';
		theReturnText += settings.months[entry.birthMonth].shortName + '&nbsp';
		theReturnText += entry.birthYear;
		theReturnText += '</div>';
		if (entry.peak) theReturnText += '<div>Peak ' + entry.peak + '</div>';
		theReturnText += '<br>';
		let gotVideo = false;
		let videoLink = null;
		if (entry.youTubeID) {
			videoLink = settings.misc.embedCode + entry.youTubeID;
			gotVideo = true;
		} else if (entry.altVideo) {
			videoLink = settings.misc.embedCode + entry.altVideo;
			gotVideo = true;
		}
		if (gotVideo) {
			theReturnText +=
				'<div class="great-player-video"><iframe width="289" height="162" src=' +
				videoLink +
				' frameborder="0" allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>';
		}
		theReturnText += '<div><br><br></div>';
	}
	return theReturnText;
}

function buildTeamRoster(
	showNumber,
	showAge,
	showCaps,
	showClub,
	showPosition,
	showNationality,
	averageAge,
	averageCaps,
	oldestName,
	oldestAge,
	youngestName,
	youngestAge,
	playerArray
) {
	let html = myBold('Players');
	if (showCaps) html += '<div>' + 'Average Caps: ' + averageCaps + '</div>';
	html += '<div>' + 'Average Age: ' + averageAge + '</div>';
	html += '<div>' + 'Oldest: ' + oldestName + ', ' + oldestAge + '</div>';
	html += '<div style="margin-bottom: -2px;">' + 'Youngest: ' + youngestName + ', ' + youngestAge + '</div>';
	let i = 0;
	let len = playerArray.length;
	let first_char = ['#', 'Name', 'Pos', 'Club', 'Caps', 'Goals', 'Age', 'Nationality'];

	html += '<div class="roster_table">';
	html += '<div>';

	if (showNumber) {
		html += '<div>';
		html += '<div class="first roster_jerseyNumber">' + first_char[0] + '</div>';
		for (i = 0; i < len; i++) {
			let theNumber = null;
			if (playerArray[i][0]) theNumber = playerArray[i][0];
			else theNumber = '&nbsp';
			html += '<div class="roster_jerseyNumber">' + theNumber + '</div>';
		}
		html += '</div>';
	}

	html += '<div>';
	html += '<div class="first roster_name">' + first_char[1] + '</div>';
	for (i = 0; i < len; i++) {
		html += '<div class="roster_name">' + playerArray[i][1] + '</div>';
	}
	html += '</div>';

	if (showPosition) {
		html += '<div>';
		html += '<div class="first rosterPosition">' + first_char[2] + '</div>';
		for (i = 0; i < len; i++) {
			html += '<div class="rosterPosition">' + playerArray[i][2] + '</div>';
		}
		html += '</div>';
	}

	if (showAge) {
		html += '<div>';
		html += '<div class="first rosterAge">' + first_char[6] + '</div>';
		for (i = 0; i < len; i++) {
			let theValue = '';
			if (playerArray[i][6]) theValue = playerArray[i][6];
			html += '<div class="rosterAge">' + theValue + '</div>';
		}
		html += '</div>';
	}

	if (showCaps) {
		html += '<div>';
		html += '<div class="first">' + first_char[4] + '</div>';
		for (i = 0; i < len; i++) {
			html += '<div>' + playerArray[i][4] + '</div>';
		}
		html += '</div>';
	}
	if (showClub) {
		html += '<div>';
		html += '<div class="first rosterClubName">' + first_char[3] + '</div>';
		let clubName = '';
		for (i = 0; i < len; i++) {
			if (playerArray[i][3]) clubName = playerArray[i][3];
			else clubName = '&nbsp';
			html += '<div class="rosterClubName">' + clubName + '</div>';
		}
		html += '</div>';
	}
	if (showNationality) {
		html += '<div>';
		html += '<div class="first">' + first_char[7] + '</div>';
		let nationality = '';
		for (i = 0; i < len; i++) {
			if (playerArray[i][7]) nationality = playerArray[i][7];
			else nationality = '&nbsp';
			html += '<div class="rosterClubName">' + nationality + '</div>';
		}
		html += '</div>';
	}

	html += '</div>';
	html += '</div>';

	return html;
}

function buildResultsIntermediateHeader(entityID, includeFlag = true, useFlagContainer = true) {
	let returnText = '';
	if (includeFlag) returnText = buildFlag(entityID, 'flag', useFlagContainer);
	if (settings.globals.currentTourny.showWinLostTieRecord) {
		let theResults = manageData.getPointsForASingleTeam(entityID);
		returnText += '<br>Wins: ' + theResults.wins + ', Losses: ' + theResults.losses + ', Ties: ' + theResults.ties;
		returnText += '<br>Points: ' + (3 * theResults.wins + theResults.ties);
	}
	if (settings.globals.currentTourny.playerListReady) {
		returnText += '<span style="display: block; margin-top: 0.3em;"></span><a href="#scheduleAnchor">' + myBold('Schedule') + '</a>';
	}
	if (settings.globals.currentTourny.historicalInfoAvailable) {
		returnText += '<br>';
		let theHostType = settings.hosts.find((k) => k.hostType === settings.globals.currentTourny.typeOfTourny);

		let first = true;
		let text = null;
		for (let theYear of theHostType.hostYears) {
			if (theYear.year < settings.globals.currentTourny.startYear) {
				//only include previous championships
				if (theYear.firstPlaceID === entityID) {
					if (first) {
						text = theYear.year;
						first = false;
					} else text += ', ' + theYear.year;
				}
			}
		}
		returnText += myBold('Previous ' + settings.globals.currentTourny.shortName + ' Champions: ');

		if (text !== null) {
			returnText += '<br>' + text + '<br><br>';
		} else returnText += '0<br>';

		let count = 0; //don't include current year
		for (let theYear of theHostType.hostYears) {
			if (theYear.year < settings.globals.currentTourny.startYear) {
				let result = theYear.participants.filter((m) => m.ID === entityID);
				count += result.length;
			}
		}

		returnText += myBold('Previous Appearances: ') + count;
		returnText += '<br>';
	}

	returnText += '<br>';
	if (settings.globals.currentTourny.showGroupInfo) {
		let groupID = manageData.getEntityGroupID(entityID);
		returnText += 'In ' + myBold('Group ' + groupID) + ' with:<br>';
		let teamsInGroup = settings.globals.currentTeams.filter((o) => o.groupID === groupID); // not error checking here because this would be caught on start up
		let fullNames = [];
		for (let theTeam of teamsInGroup)
			if (theTeam.ID !== entityID) fullNames.push(manageData.getProperEntityName(theTeam.ID));
		// Sort team names alphabetically
		fullNames.sort();
		// If the group only has 3 teams total (not all 4 known yet), add 'TBD' at the end
		if (teamsInGroup.length === 3) {
			fullNames.push('TBD');
		}
		for (let i = 0; i < fullNames.length; i++) {
			if (i < fullNames.length - 1) returnText += fullNames[i] + ', ';
			else returnText += fullNames[i];
		}
		returnText += '<br>';
	}
	return returnText;
}

/*
 * @param whichLayerIndex
 * This function is the beginning of all steps necessary
 * to switch from one layer (or multiple layers) to others.
 */

function switchModes(whichLayerIndex) {
	// COMMENTED OUT: Previous conditional security check - now always enforced for mandatory login
	// Previously: Security checks only ran if enableSecurity was true AND layer had loginRequired flag
	// if (settings.misc.enableSecurity) {
	//     let checkSecurity = false;
	//     if (
	//         settings.globals.currentTourny.loginRequired &&
	//         settings.globals.layerParameters[whichLayerIndex].loginRequired === 'tournamentDependent'
	//     )
	//         checkSecurity = true;
	//     else if (settings.globals.layerParameters[whichLayerIndex].loginRequired === 'always') checkSecurity = true;
	//     if (checkSecurity) {
	//         // COMMENTED OUT: Subscription-based access control removed - system now uses authentication-only
	//         // Previously checked for active Stripe subscription (activeSubscription):
	//         // if (settings.globals.firebase.activeSubscription) {
	//         //     if (whichLayerIndex === settings.layerIndices.subscribeLayerIndex)
	//         //         whichLayerIndex = settings.layerIndices.logInLayerIndex; //if already subscribed but the user chose subscription, just show them that they are already subscribed
	//         //     else; // there is a subscription, doNothing, just proceed
	//         // } else {
	//         //     //take them through the subsciption process
	//         //     settings.globals.firebase.callBackLayerIndex = whichLayerIndex;
	//         //     whichLayerIndex = settings.layerIndices.subscribeLayerIndex; //force into subscription system
	//         // }
	//
	//         // NEW: Authentication-only access control (no subscription required)
	//         if (settings.globals.firebase.currentUserID) {
	//             // User is authenticated, allow access
	//             if (whichLayerIndex === settings.layerIndices.subscribeLayerIndex)
	//                 whichLayerIndex = settings.layerIndices.logInLayerIndex; //if already logged in but chose login layer, show logged in message
	//             else; // user is authenticated, proceed with requested layer
	//         } else {
	//             // User is not authenticated, redirect to login
	//             settings.globals.firebase.callBackLayerIndex = whichLayerIndex;
	//             whichLayerIndex = settings.layerIndices.subscribeLayerIndex; //force into login system
	//         }
	//     }
	// }

	// NEW: Always check authentication for mandatory login (no layer-specific exceptions)
	// All site access requires authentication regardless of enableSecurity flag or layer loginRequired setting
	if (settings.globals.firebase.currentUserID) {
		// User is authenticated, allow access to requested layer
		if (whichLayerIndex === settings.layerIndices.subscribeLayerIndex)
			whichLayerIndex = settings.layerIndices.logInLayerIndex; //if already logged in but chose login layer, show logged in message
		// else: user is authenticated, proceed with requested layer
	} else {
		// User is not authenticated, redirect to login
		settings.globals.firebase.callBackLayerIndex = whichLayerIndex;
		whichLayerIndex = settings.layerIndices.subscribeLayerIndex; //force into login system
	}

	// COMMENTED OUT: Previous version assumed map always exists
	// Previously: Called dumpLayers and addLayerAndExtras without checking if map is initialized
	// dumpLayers();
	// addLayerAndExtras(whichLayerIndex);
	// NEW: Check if map is initialized before proceeding (prevents "eachLayer" error during login flow)
	if (!settings.globals.map) {
		console.warn('Map not initialized yet, cannot switch modes. Layer index:', whichLayerIndex);
		console.warn('This may happen during login flow - initialization will complete shortly');
		// Store the requested layer index to switch to after initialization completes
		if (whichLayerIndex !== settings.layerIndices.subscribeLayerIndex) {
			settings.globals.firebase.callBackLayerIndex = whichLayerIndex;
		}
		return; // Exit early - initialization will complete and then switch to the requested layer
	}

	dumpLayers();
	addLayerAndExtras(whichLayerIndex);
}

function updateLegendTitle(entityName) {
	document.getElementById('versusField').innerHTML = 'Versus ' + entityName;
}

function updateLegendDate(theDate) {
	document.getElementById('dateGoesHere').innerHTML = theDate;
}
function noMatchOnGivenDay(whichTeamID) {
	return myBold(manageData.getProperEntityName(whichTeamID)) + ' did not play on selected date.';
}

/**
 * Sets up sticky section header that updates as user scrolls through sections
 */
function setupStickySectionHeader() {
	const stickyHeader = document.getElementById('stickySectionHeader');
	const leftBarContainer = document.getElementById('LeftBarContainer');

	if (!stickyHeader || !leftBarContainer) {
		return; // Elements not found, exit early
	}

	const sectionHeaders = leftBarContainer.querySelectorAll('.LeftBarTitle');

	if (sectionHeaders.length === 0) {
		// No section headers found, hide sticky header
		stickyHeader.style.display = 'none';
		return;
	}

	// Set initial sticky header text from first section header
	const firstHeader = sectionHeaders[0];
	const firstHeaderText = firstHeader.textContent.trim();
	stickyHeader.textContent = firstHeaderText;
	stickyHeader.style.display = 'flex';

	// Hide the first section header initially since sticky header shows it
	firstHeader.style.visibility = 'hidden';
	firstHeader.style.height = '0';
	firstHeader.style.overflow = 'hidden';
	firstHeader.style.margin = '0';
	firstHeader.style.padding = '0';

	// Track scroll direction
	let lastScrollTop = leftBarContainer.scrollTop;
	let currentActiveIndex = 0; // Track which header is currently active (at top)

	// Function to get header text
	const getHeaderText = (header) => {
		return header.textContent.trim();
	};

	// Function to hide a header
	const hideHeader = (header) => {
		header.style.visibility = 'hidden';
		header.style.height = '0';
		header.style.overflow = 'hidden';
		header.style.margin = '0';
		header.style.padding = '0';
	};

	// Function to show a header
	const showHeader = (header) => {
		header.style.visibility = '';
		header.style.height = '';
		header.style.overflow = '';
		header.style.margin = '';
		header.style.padding = '';
	};

	// Function to update sticky header based on scroll position
	const updateStickyHeader = () => {
		const containerRect = leftBarContainer.getBoundingClientRect();
		const stickyHeaderHeight = 40; // Height of sticky header
		const scrollTop = leftBarContainer.scrollTop;
		const isScrollingDown = scrollTop > lastScrollTop;
		lastScrollTop = scrollTop;

		let newActiveIndex = -1;
		let newActiveHeader = null;

		// Find which header should be active (at or just past the top)
		for (let i = 0; i < sectionHeaders.length; i++) {
			const header = sectionHeaders[i];
			const headerRect = header.getBoundingClientRect();
			const headerTop = headerRect.top;
			const containerTop = containerRect.top;

			// Check if header is at or above the sticky position
			// Account for sticky header height
			if (headerTop <= containerTop + stickyHeaderHeight + 5) {
				newActiveIndex = i;
				newActiveHeader = header;
			} else {
				// Headers are in order, so if this one is below, we can stop
				break;
			}
		}

		// If no header found, use the last one (shouldn't happen, but safety check)
		if (newActiveIndex === -1) {
			newActiveIndex = sectionHeaders.length - 1;
			newActiveHeader = sectionHeaders[newActiveIndex];
		}

		// Update sticky header text if active header changed
		if (newActiveIndex !== currentActiveIndex) {
			const newHeaderText = getHeaderText(newActiveHeader);
			stickyHeader.textContent = newHeaderText;

			// Show the previous active header (if it exists and we're scrolling)
			if (currentActiveIndex >= 0 && currentActiveIndex < sectionHeaders.length) {
				const previousHeader = sectionHeaders[currentActiveIndex];
				showHeader(previousHeader);
			}

			// Hide the new active header
			hideHeader(newActiveHeader);

			currentActiveIndex = newActiveIndex;
		} else {
			// Same header is active, but make sure it's hidden
			if (newActiveHeader) {
				hideHeader(newActiveHeader);
			}

			// Show all other headers
			sectionHeaders.forEach((header, index) => {
				if (index !== currentActiveIndex) {
					showHeader(header);
				}
			});
		}
	};

	// Use Intersection Observer for more reliable detection
	const observerOptions = {
		root: leftBarContainer,
		rootMargin: '-1px 0px 0px 0px', // Trigger when header reaches top
		threshold: [0, 0.1, 0.5, 1]
	};

	const observer = new IntersectionObserver((entries) => {
		updateStickyHeader();
	}, observerOptions);

	// Observe all section headers
	sectionHeaders.forEach((header) => {
		observer.observe(header);
	});

	// Also listen to scroll events for better responsiveness
	let scrollTimeout;
	leftBarContainer.addEventListener('scroll', () => {
		clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(() => {
			updateStickyHeader();
		}, 10); // Debounce scroll events
	});

	// Initial update
	updateStickyHeader();

	// Update again after a short delay to ensure DOM is ready
	setTimeout(() => {
		updateStickyHeader();
	}, 100);
}

window.handleVideo = manageVideo.handleVideo;
window.switchModes = switchModes;

export {
	updateLegendTitle,
	switchModes,
	handleCoffee,
	handlePrivacy,
	handleTerms,
	handleSendEmail,
	buildAbout,
	buildManageAccount,
	buildNewsLetter,
	buildTeamRoster,
	buildRankingsPopUp,
	buildUpcomingGamePopUp,
	//
	buildHostPopUp,
	buildNoHostPopUp,
	//
	buildNoGreatPlayerPopUp,
	buildGreatPlayerPopUp,
	//
	buildQualifyingHistoryPopUpBody,
	buildDidQualifyPopUp,
	buildDidNotQualifyPopUp,
	buildQualifyingPopUp,
	//
	buildLostInPreviousPopUp,
	buildDidAdvancePopUp,
	buildDidNotAdvancePopUp,
	//
	buildSingleMatchPopUp,
	buildNextLine,
	buildFullResultsPopUp,
	//
	buildTalentFlowToCountryPopUp,
	buildToCountryMarkersPopUp,
	//
	buildTalentFlowFromConfederationPopUp,
	buildTalentFlowToConfederationPopUp,
	//
	buildGroupPopUp,
	buildGroupPopUpBody,
	//
	buildTalentFlowFromCountryPopUp,
	buildFromCountryMarkersPopUp,
	//
	buildFanMarkersPopUp,
	//
	buildFlag,
	//
	myBold,
	//
	addSideBarActiveClass,
	addHeaderActiveClass,
	addPicsGroupActiveClass,
	highlightMenuForLayer,
	//
	buildSideBarPicsForCurrentFromCountry,
	buildSideBarPicsForCurrentTeam,
	//
	buildLegend,
	//
	dumpLayers,
	//
	initializeMenuAndSideBar,
	//
	buildLogOut,
	buildLogIn,
	buildHelp,
	buildComingSoon,
	buildEmailThankYou,
	buildCoffee,
	buildTerms,
	buildPrivacy,
	buildSubscribe,
	bringInDataViz,
	buildMenuSections,
	//
	buildSideBarText,
	buildResultsIntermediateHeader,
	replaceUserDependentMenu,
	updateLegendDate,
	noMatchOnGivenDay
};
